export const accentRegex = '[ñÑáéíóúÁÉÍÓÚ]';
